module.exports = __webpack_public_path__ + "img/roll11.76715f23.png";